export const routes = [
  {
    name: "Overview",
    route_name: "overview",
    description: "Company's general overview",
  },
  {
    name: "Financials",
    route_name: "financials",
    description: "Shows the company's financials",
  },
  {
    name: "Financial Trend",
    route_name: "financial-trend",
    description: "The company's financial performance trend",
  },
  // {
  //   name: "Description",
  //   route_name: "description",
  //   description: "Gives and indepth description of the company's operating & supporting activities",
  // },
  {
    name: "Directors",
    route_name: "directors",
    description: "The company's directors",
  },
  {
    name: "Management",
    route_name: "management",
    description: "The top management team",
  },
  // {
  //   name: "Company News",
  //   route_name: "news",
  //   description: "News that are related to the company",
  // },
  // {
  //   name: "Company Events",
  //   route_name: "events",
  //   description: "All past and upcoming company's events",
  // },
  // {
  //   name: "Corporate Actions",
  //   route_name: "actions",
  //   description: "All past and upcoming corporate actions(i.e. Dividend payouts)",
  // },
  // {
  //   name: "Earnings & Estimates",
  //   route_name: "earnings-and-estimates",
  //   description: "Past and upcoming earnings and estimates",
  // },
  // {
  //   name: "Comparative Analytics",
  //   route_name: "comparative-analytics",
  //   description: "Comparable companies with similar business models and in the same sector",
  // },
  {
    name: "Company Filings",
    route_name: "filings",
    description: "All the company's regulatory filings",
  },
  // {
  //   name: "Research",
  //   route_name: "research",
  //   description: "Comprehensive company research both proprietary and third party research",
  // },
];
